"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var findClosestDpr = function findClosestDpr(result, target) {
  return result.reduce(function (prev, curr) {
    return Math.abs(curr.dpr - target) < Math.abs(prev.dpr - target) ? curr : prev;
  });
};

exports.default = findClosestDpr;